<div class="page-container">
<header style="border-bottom: 1px soild lightgray">
    <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
        <span>
            Quick Chat AI
        </span>
        <button [attr.guide]="'geminichat-btn-1' + '__' + sanitizeUrl(url)" mat-icon-button fxLayoutAlign="center center">
            <mat-icon (click)="closeDialog()">
                close
            </mat-icon>
        </button>
    </div>
</header>
  <main>
    <div class="section" fxFlex fxLayout="column" fxLayoutAlign="center" fxLayout.xs="row">
        <div id="messageContainer" #messageContainer class="chat" fxFlex fxLayout="column">
          <ng-container *ngFor="let item of chatHistory">
            <div class="messages" [ngClass]="{'user-message': item.from === 'user', 'bot-message': item.from === 'bot'}" fxLayout="row" [fxLayoutAlign]="item.from === 'user' ? 'start center' : 'end center'">
              <!-- <mat-icon *ngIf="item.from === 'user'">person</mat-icon>
              <mat-icon *ngIf="item.from === 'bot'">chat</mat-icon> -->
              <span class="responses" [ngClass]="{'user-text': item.from === 'user', 'bot-text': item.from === 'bot'}" [innerHTML]="formatText(item.message)"></span>
              <div *ngIf="item.from === 'bot'">
              <mat-icon *ngIf="!item.copied" class="copy-icon" matTooltip="Copy to clipboard" (click)="copyMessage(item)">content_copy</mat-icon>
              <mat-icon *ngIf="item.copied" class="tick-icon" matTooltip="Copied">done</mat-icon>
                </div>
            </div>
          </ng-container>
          <ng-container *ngIf="loading">
            <div class="spinner-grow" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </ng-container>
        </div>
      </div>
      
                  
  </main>
  <footer style="border: 1px solid lightgray;border-radius: 50px;margin-bottom: 5px;">
    <div  fxLayout.xs="row" fxLayout="row">
        <div fxFlex="5"></div>
        <div fxFlex="85" style="padding-top: 12px;">
            <input [attr.guide]="'geminichat-inp-message-input' + '__' + sanitizeUrl(url)" id="message-input" type="textArea" (keyup.enter)="sendData()" placeholder="Type here...." [(ngModel)]="promt" [disabled]="loading" autocomplete="off"/>

        </div>
        <div fxFlex="12" fxLayoutAlign="center center">
            <button [attr.guide]="'geminichat-btn-2' + '__' + sanitizeUrl(url)" (click)="sendData()" [disabled]="loading" >
                <mat-icon>send</mat-icon></button>        
        </div>
        <div fxFlex="3"></div>
    </div>  
  </footer>
</div>